export const setUserToken = (data) => {
  localStorage.setItem("userToken", JSON.stringify(data));
};
export const setUserData = (data) => {
  localStorage.setItem("userData", JSON.stringify(data));
};
export const getUserToken = () => {
  const token = localStorage.getItem("userToken") || "";
  return token;
};
export const getUserData = () => {
  const userData = localStorage.getItem("userData") || {};
  return userData;
};

export const setCustomDateType = (data) => {
  localStorage.setItem("customDate", JSON.stringify(data));
};
export const getCustomDateType = () => {
  const customDate = localStorage.getItem("customDate");
  return customDate;
};
export const isValidEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};
export const isValidPassword = (password) => {
  const passwordRegex =
    /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/;
  return passwordRegex.test(password);
};
export const formatCurrency = (value) => {
  if (!value || isNaN(value)) return "$0.00";

  const num = Number(value);
  const abs = Math.abs(num);

  // If amount is 1 Million or more, show as $1.25M
  if (abs >= 1000000) {
    return `$${(num / 1000000).toFixed(2)}M`;
  }
  // Standard currency formatting ($1,234.56)
  return num.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
